import React from "react";
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { billingSubscribe } from '@/store/billing'

import AppBox from "@/components/AppBox";
import AppButton from "@/components/AppButton";
import AppInput from "@/components/AppInput";
import AppText from "@/components/AppText";

// Props Interface
interface BillingInfoProps {
  onClickChange: () => void;
  onCancelSubscription: () => void;
}

// Icons
const VisaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 141.732 141.732"
  >
    <path
      d="M62.935 89.571h-9.733l6.083-37.384h9.734zM45.014 52.187 35.735 77.9l-1.098-5.537.001.002-3.275-16.812s-.396-3.366-4.617-3.366h-15.34l-.18.633s4.691.976 10.181 4.273l8.456 32.479h10.141l15.485-37.385H45.014zm76.555 37.384h8.937l-7.792-37.385h-7.824c-3.613 0-4.493 2.786-4.493 2.786L95.881 89.571h10.146l2.029-5.553h12.373l1.14 5.553zm-10.71-13.224 5.114-13.99 2.877 13.99h-7.991zm-14.217-15.17 1.389-8.028s-4.286-1.63-8.754-1.63c-4.83 0-16.3 2.111-16.3 12.376 0 9.658 13.462 9.778 13.462 14.851s-12.075 4.164-16.06.965l-1.447 8.394s4.346 2.111 10.986 2.111c6.642 0 16.662-3.439 16.662-12.799 0-9.72-13.583-10.625-13.583-14.851.001-4.227 9.48-3.684 13.645-1.389z"
      fill="#2566af"
    />
    <path
      d="m34.638 72.364-3.275-16.812s-.396-3.366-4.617-3.366h-15.34l-.18.633s7.373 1.528 14.445 7.253c6.762 5.472 8.967 12.292 8.967 12.292z"
      fill="#e6a540"
    />
    <path fill="none" d="M0 0h141.732v141.732H0z" />
  </svg>
);

const MasterCardIcon = () => (
  <svg
    data-name="Laag 1"
    width={24}
    height={24}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2000 1556"
  >
    <title>{"Tekengebied 1"}</title>
    <path
      d="M1960.59 1534.9v4h3.73a3.93 3.93 0 0 0 2-.51 1.78 1.78 0 0 0 .75-1.53 1.71 1.71 0 0 0-.75-1.49 3.59 3.59 0 0 0-2-.51h-3.73Zm3.77-2.83a6.92 6.92 0 0 1 4.48 1.3 4.3 4.3 0 0 1 1.57 3.54 4.06 4.06 0 0 1-1.26 3.11 6.14 6.14 0 0 1-3.58 1.49l5 5.7h-3.85l-4.6-5.66h-1.49v5.66h-3.22v-15.13h7Zm-1 20.36a12 12 0 0 0 4.91-1 12.86 12.86 0 0 0 4-2.71 12.63 12.63 0 0 0 2.71-4 12.94 12.94 0 0 0 0-9.9 13.07 13.07 0 0 0-2.71-4 12.89 12.89 0 0 0-4-2.71 12.59 12.59 0 0 0-4.91-.94 13.12 13.12 0 0 0-5 .94 12.77 12.77 0 0 0-4.09 2.71 12.92 12.92 0 0 0-2.67 14 11.92 11.92 0 0 0 2.67 4 12.81 12.81 0 0 0 4.09 2.71 12.45 12.45 0 0 0 5 1m0-29a16.74 16.74 0 0 1 11.75 4.8 16 16 0 0 1 3.54 5.19 16.09 16.09 0 0 1 0 12.65 16.88 16.88 0 0 1-3.54 5.19 17.85 17.85 0 0 1-5.27 3.5 16.33 16.33 0 0 1-6.48 1.3 16.6 16.6 0 0 1-6.56-1.3 17.08 17.08 0 0 1-5.31-3.5 16.88 16.88 0 0 1-3.49-5.36 16.09 16.09 0 0 1 0-12.65 16 16 0 0 1 3.54-5.19 15.8 15.8 0 0 1 5.31-3.5 16.6 16.6 0 0 1 6.56-1.3M432.16 1465.1c0-28.85 18.9-52.55 49.79-52.55 29.52 0 49.44 22.68 49.44 52.55s-19.92 52.55-49.44 52.55c-30.89 0-49.79-23.7-49.79-52.55m132.88 0V1383h-35.69v20c-11.32-14.78-28.49-24.05-51.84-24.05-46 0-82.1 36.08-82.1 86.19s36.08 86.19 82.1 86.19c23.34 0 40.52-9.28 51.84-24.05v19.93H565v-82.11Zm1205.92 0c0-28.85 18.9-52.55 49.8-52.55 29.55 0 49.44 22.68 49.44 52.55s-19.89 52.55-49.44 52.55c-30.89 0-49.8-23.7-49.8-52.55m132.92 0v-148h-35.72v85.9c-11.32-14.78-28.49-24.05-51.84-24.05-46 0-82.1 36.08-82.1 86.19s36.08 86.19 82.1 86.19c23.35 0 40.52-9.28 51.84-24.05v19.93h35.72v-82.11ZM1008 1410.86c23 0 37.77 14.42 41.54 39.81h-85.16c3.81-23.7 18.2-39.81 43.63-39.81m.71-32c-48.1 0-81.75 35-81.75 86.19 0 52.19 35 86.19 84.14 86.19 24.72 0 47.36-6.17 67.28-23l-17.49-26.45c-13.76 11-31.28 17.17-47.75 17.17-23 0-43.94-10.65-49.09-40.2h121.87c.35-4.44.71-8.92.71-13.72-.36-51.17-32-86.19-77.94-86.19m430.9 86.19c0-28.85 18.9-52.55 49.79-52.55 29.52 0 49.44 22.68 49.44 52.55s-19.92 52.55-49.44 52.55c-30.89 0-49.8-23.7-49.8-52.55m132.88 0V1383h-35.67v20c-11.36-14.78-28.49-24.05-51.84-24.05-46 0-82.1 36.08-82.1 86.19s36.08 86.19 82.1 86.19c23.35 0 40.48-9.28 51.84-24.05v19.93h35.68v-82.11Zm-334.42 0c0 49.79 34.66 86.19 87.56 86.19 24.72 0 41.19-5.5 59-19.57l-17.14-28.85c-13.4 9.63-27.47 14.78-43 14.78-28.49-.35-49.44-20.95-49.44-52.55s20.95-52.19 49.44-52.55c15.49 0 29.56 5.15 43 14.78l17.14-28.85c-17.84-14.07-34.31-19.57-59-19.57-52.9 0-87.56 36.39-87.56 86.19m460.1-86.19c-20.59 0-34 9.63-43.27 24.05V1383h-35.37v164.12h35.73v-92c0-27.16 11.67-42.25 35-42.25a57.87 57.87 0 0 1 22.32 4.13l11-33.64c-7.9-3.11-18.2-4.48-25.43-4.48m-956.64 17.17c-17.17-11.32-40.83-17.17-66.93-17.17-41.58 0-68.35 19.93-68.35 52.54 0 26.76 19.93 43.27 56.63 48.42l16.86 2.4c19.57 2.75 28.81 7.9 28.81 17.17 0 12.69-13 19.93-37.41 19.93-24.72 0-42.56-7.9-54.59-17.17L599.74 1530c19.57 14.42 44.29 21.3 71.06 21.3 47.4 0 74.87-22.32 74.87-53.57 0-28.85-21.62-43.94-57.34-49.09l-16.82-2.44c-15.45-2-27.83-5.11-27.83-16.11 0-12 11.67-19.22 31.25-19.22 20.95 0 41.23 7.9 51.17 14.07l15.45-28.85Zm460.51-17.14c-20.59 0-34 9.63-43.23 24.05V1383h-35.37v164.12h35.69v-92c0-27.16 11.67-42.25 35-42.25a57.87 57.87 0 0 1 22.32 4.13l11-33.64c-7.9-3.11-18.2-4.48-25.43-4.48M897.44 1383h-58.36v-49.79H803V1383h-33.29v32.62H803v74.87c0 38.08 14.78 60.76 57 60.76 15.49 0 33.33-4.8 44.65-12.69L894.34 1508c-10.65 6.17-22.32 9.28-31.6 9.28-17.84 0-23.66-11-23.66-27.47v-74.16h58.36Zm-533.59 164.16v-103c0-38.79-24.72-64.89-64.57-65.24-20.95-.35-42.56 6.17-57.69 29.2-11.32-18.2-29.16-29.2-54.24-29.2-17.53 0-34.66 5.15-48.07 24.37V1383h-35.72v164.12h36v-91c0-28.49 15.8-43.63 40.2-43.63 23.7 0 35.69 15.45 35.69 43.27v91.34h36.08v-91c0-28.49 16.47-43.63 40.16-43.63 24.37 0 36 15.45 36 43.27v91.34Z"
      style={{
        fill: "#231f20",
      }}
    />
    <path
      d="M1980.94 1001.22v-24h-6.25l-7.23 16.47-7.19-16.47H1954v24h4.44v-18.08l6.76 15.6h4.6l6.76-15.64v18.12h4.4Zm-39.65 0v-19.89h8v-4.05h-20.44v4.05h8v19.89h4.4Z"
      style={{
        fill: "#f79410",
      }}
    />
    <path
      d="M1270.57 1104.15H729.71v-972h540.87Z"
      style={{
        fill: "#ff5f00",
      }}
    />
    <path
      d="M764 618.17c0-197.17 92.32-372.81 236.08-486A615.46 615.46 0 0 0 618.09 0C276.72 0 0 276.76 0 618.17s276.72 618.17 618.09 618.17a615.46 615.46 0 0 0 382-132.17C856.34 991 764 815.35 764 618.17"
      style={{
        fill: "#eb001b",
      }}
    />
    <path
      d="M2000.25 618.17c0 341.41-276.72 618.17-618.09 618.17a615.65 615.65 0 0 1-382.05-132.17c143.8-113.19 236.12-288.82 236.12-486s-92.32-372.81-236.12-486A615.65 615.65 0 0 1 1382.15 0c341.37 0 618.09 276.76 618.09 618.17"
      style={{
        fill: "#f79e1b",
      }}
    />
  </svg>
);

// Component
const BillingInfo: React.FC<BillingInfoProps> = ({
  onClickChange,
  onCancelSubscription,
}) => {
  const dispatch = useAppDispatch();

  // State selectors
  const { me } = useAppSelector((state: any) => state.auth);
  const { subscriptionStatus } = useAppSelector((state: any) => state.billing);

  // Handle restore subscription
  const handleRestoreSubscription = () => {
    // await dispatch(subscribeAndReturnUser());
    dispatch(billingSubscribe());
  };

  // Handle restore subscription
  const handleChangeInput = (value: any) => {
    console.log('Changing payment method is currently is under construction.')
  };

  // Determine the credit card icon
  const getCardByType = (type: string) => {
    switch (type) {
      case "visa":
        return <VisaIcon />;
      case "mastercard":
        return <MasterCardIcon />;
      default:
        return null;
    }
  };

  return me.isSubscribed && me.isCanceled ? (
    <AppBox width={180} justify="center">
      <AppButton onClick={handleRestoreSubscription} isLoading={subscriptionStatus === "loading"}>
        Restore Subscription
      </AppButton>
    </AppBox>
  ) : (
    // <AppBox column gap={2} width={isMobile ? "auto" : 520}>
    <AppBox column gap={2} width={420}>
      <AppInput
        type="text"
        // label="Credit Card"
        value={`**** **** **** ${me.cardLastFour}`}
        disabled
        endAdornment={getCardByType(me.cardType)}
        onChange={handleChangeInput}
      />
      <AppBox justify="between" gap={4}>
        <AppBox width={120}>
          <AppButton onClick={onClickChange}>Change</AppButton>
        </AppBox>
        <AppBox width={176}>
          <AppButton
            onClick={onCancelSubscription}
            variant="outlined"
            isLoading={subscriptionStatus === "loading"}
          >
            Cancel Subscription
          </AppButton>
        </AppBox>
      </AppBox>
    </AppBox>
  );
};

export default BillingInfo;